export const EXLY_SUPPORT_WIDGET_CONSTANTS = {
  // Default theme configuration
  DEFAULT_THEME: {
    primaryColor: "#4A3AB1",
    textColor: "#ffffff",
    backgroundColor: "#ffffff",
    borderColor: "#e5e7eb",
    borderRadius: "12px",
    shadowColor: "rgba(0,0,0,0.1)",
    buttonColor: "#4A3AB1",
    buttonHoverColor: "#3A2A91",
    messageBubbleColor: "#4A3AB1",
    assistantBubbleColor: "#f8fafc",
    assistantTextColor: "#1e293b",
  },

  // Default position
  DEFAULT_POSITION: "bottom-right",

  // Widget element tag name
  WIDGET_ELEMENT_TAG: "exly-support-widget",

  // CSS selector patterns
  CSS_SELECTORS: {
    SUPPORT_WIDGET_CSS: 'link[href*="exly-support-widget.css"]',
    SUPPORT_WIDGET_SCRIPT: 'script[src*="exly-support-widget"]',
  },

  // Widget attributes
  WIDGET_ATTRIBUTES: {
    USER_EMAIL: "user_email",
    CLIENT_ID: "client_id",
    NAME: "name",
    SUB_DOMAIN: "sub_domain",
    POSITION: "position",
    HIDE_CLOSE_BUTTON: "hideCloseButton",
    THEME: "theme",
    CUSTOM_CSS: "customCss",
  },

  // Default values
  DEFAULT_VALUES: {
    CLIENT_ID: "default",
    HIDE_CLOSE_BUTTON: "true",
  },

  // Environment variable names
  ENV_VARS: {
    SUPPORT_WIDGET_ENABLED: "REACT_APP_SUPPORT_WIDGET_ENABLED",
    SUPPORT_WIDGET_CSS_URL: "REACT_APP_SUPPORT_WIDGET_CSS_URL",
    SUPPORT_WIDGET_URL: "REACT_APP_SUPPORT_WIDGET_URL",
  },

  // Environment variable values
  ENV_VALUES: {
    ENABLED: "true",
  },
};
